import { Component, OnInit, Input } from '@angular/core';
import { JobcardService } from '../../../../services/jobcard.service';


@Component({
  selector: 'app-jobcard-attachments',
  templateUrl: './jobcard-attachments.component.html',
  styleUrls: ['./jobcard-attachments.component.scss']
})
export class JobcardAttachmentsComponent implements OnInit {

  @Input() jobcard;
  @Input() messageService;
  public attachments: any = [];
  public loading: boolean = false;
  public qrIdentifier: string = ""
  public url: string = "";
  public mounted: boolean = false;

  constructor(
    private jobcardService: JobcardService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.mounted = true;
    this.getAttachments();
    this.jobcardService.getJobCardQRIdentifier(this.jobcard.ID).subscribe(result => {
      this.url = window.location.origin + '/cyclist/jobcardAttachments/' + this.jobcard.ID + '?QRCodeIdentifier=' + result.qrCodeIdentifier + "&Theme=" + this.jobcard.PartnerID;
    })
  }

  ngOnDestroy(): void {
    this.mounted = false;
  }

  getAttachments(){    
    console.log(this.jobcard.PartnerID || this.jobcard.partner.partnerID);
    var partnerID = this.jobcard.PartnerID || this.jobcard.partner.partnerID;
    this.jobcardService.getJobCardAttachmentsV1(this.jobcard.ID, this.jobcard.bikeID, partnerID).subscribe(attachments=>{
      this.attachments = attachments;
      this.loading = false;
    });
    setTimeout(() => {
      if (this.mounted) {
        this.getAttachments();
      }
    }, 10000);
  }

  deleteAttachment(attachment) {
    this.loading = true;
    this.jobcardService.deleteJobCardAttachment(attachment.id).subscribe(attachments => {
      this.getAttachmentsFromResponse(attachments);
      this.loading = false;
    })
  }

  async addAttachment(event) {
    if (event.target.files && event.target.files.length > 0) {
      for (var i = 0; i < event.target.files.length; i++) {
        var file = event.target.files[i];
        var data = await this.readFileAsync(file);

        var attachment = {
          ServiceLogID: 0,
          ServiceID: this.jobcard.ID,
          MediaType: file.type,
          MediaData: data,
          FileName: file.name
        };
        this.loading = true;
        this.jobcardService.addJobCardAttachment(attachment).subscribe(attachments => {
          this.getAttachmentsFromResponse(attachments);
          this.loading = false;
        });

      };
    }
  }

  getAttachmentsFromResponse(response) {
    const jobCardAttachments = response.find(x => x.jobCardNo === this.jobcard.JobCardID.toString());
    if (jobCardAttachments != null) {
      this.attachments = jobCardAttachments.attachments;
    }
  }

  readFileAsync(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result.toString());
      };
      reader.onerror = reject;
    })
  }

  openAttachment(item) {
    window.open(item.mediaURL, "_blank")
  }

}
